// HavJoy shape print masks v1
(function(){'use strict';
if(window.HavjoyPurchase)return;
var nextOptionLabelId=0;
window.HavjoyPurchase={create:function(ctx){
var {REQUEST_TIMEOUT_MS,Shopify,appendTextSuggestions,applyCompletedMockup,bundle,canShop,chooseCompletedMockup,clearError,clearLoadingMessageTimer,closeModal,closeSafariModalBeforePageUpdate,createCompletedResult,elements,fetchWithTimeout,fieldsValid,fileInput,form,hideOverlayPreview,isModalOwner,isSafari,loadPersonalizationTemplate,mainOptionControls,mainProduct,modal,multiPhoto,normalizeProduct,openModal,preserveSafariPagePosition,productData,productRoot,renderFields,resetLoadingVisual,resolveVariantMockup,revokeLocalPhotoPreview,scope,selectedVariant,setAttr,setData,setDisplay,setLive,setLocalPhotoPreview,setMockupStatus,setOverlayPreview,setProp,setStatus,setText,showDetails,showError,showJobError,pendingJobFor,showProcessing,showUploadStep,state,submitGenerationJob,syncBundleGallery,syncMockupGallery,uploadPersonalizationFile,validateField,warmGenerationPreview}=ctx;
var external=ctx.externalPurchase;
var cartPropertiesCache=new WeakMap();
var messageCard = scope.querySelector('hj-message-card');
function cardPrice() { return messageCard && typeof messageCard.price === 'function' ? messageCard.price() : 0; }
function cardSignature() { return messageCard && typeof messageCard.signature === 'function' ? messageCard.signature() : ''; }
function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

function colorSwatchMarkup(value) {
    var colors = { black: '#171717', white: '#ffffff', navy: '#202b47',
      'dark chocolate': '#382820', chocolate: '#493229', brown: '#6a4736',
      sand: '#d8c7a8', natural: '#eee5cf', cream: '#f3ead5', ivory: '#f5f0df',
      beige: '#d7c4a3', grey: '#909090', gray: '#909090', charcoal: '#454545',
      'sport grey': '#afafaf', 'sport gray': '#afafaf', 'dark heather': '#66666b',
      'heather grey': '#aaa9a7', 'heather gray': '#aaa9a7',
      red: '#bd2830', maroon: '#682637', burgundy: '#672b3b',
      pink: '#e7a9bd', 'light pink': '#f1ccdc', blue: '#376ba3',
      'light blue': '#a9cddd', royal: '#2852a0', 'royal blue': '#2852a0',
      green: '#46714a', 'forest green': '#294b38', 'military green': '#656c46',
      olive: '#737449', purple: '#79538c', orange: '#e88738', yellow: '#ecc75b' };
    var key = String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
    var color = Object.prototype.hasOwnProperty.call(colors, key) ? colors[key] : '';
    var label = document.createElement('span');
    label.className = 'hj-color-swatch__name';
    label.textContent = value;
    return (color ? '<span class="hj-color-swatch__chip" style="background-color:' + color + '" aria-hidden="true"></span>' : '') + label.outerHTML;
  }

function productTypeIconMarkup(value) {
    var key = String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
    if (scope.hasAttribute('data-ornament-pdp') && ['heart','round','star'].includes(key)) {
      var shape = key === 'heart' ? '<path d="M16 28 4.8 17.1C-2 9.9 8.3 1.3 16 9.2 23.7 1.3 34 9.9 27.2 17.1Z"/>' : key === 'star' ? '<path d="m16 3 4 8.5 9.3 1.2-6.8 6.5 1.7 9.3-8.2-4.4-8.2 4.4 1.7-9.3-6.8-6.5 9.3-1.2Z"/>' : '<circle cx="16" cy="17" r="12"/>';
      return '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true">'+shape+'<circle cx="16" cy="11" r="1.5"/></svg>';
    }
    if (key === 't shirt' || key === 'tshirt' || key === 'tee') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M22 11c1.9 4 5.2 6 10 6s8.1-2 10-6l12 7-7 12-6-4v27H23V26l-6 4-7-12 12-7Z"/><path d="M24 12c1 2.2 3.7 3.5 8 3.5s7-1.3 8-3.5"/></svg>';
    }
    if (key === 'hoodie') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M23 16c1.2-6 4.2-9 9-9s7.8 3 9 9l9 6 6 23-9 3-5-14v20H22V34l-5 14-9-3 6-23 9-6Z"/><path d="M24 16c1.8 3.2 4.5 4.8 8 4.8s6.2-1.6 8-4.8M25 45h14l4 6H21l4-6Z"/><path d="m28 21-2 11m10-11 2 11"/></svg>';
    }
    if (key === 'sweatshirt' || key === 'sweater') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M23 12c1.8 3.5 4.8 5.2 9 5.2s7.2-1.7 9-5.2l9 5 7 24-9 3-6-16v26H22V28l-6 16-9-3 7-24 9-5Z"/><path d="M24 13c1.2 1.7 3.9 2.6 8 2.6s6.8-.9 8-2.6M22 49h20"/></svg>';
    }
    if (key === 'tank top' || key === 'tank' || key === 'singlet') {
      return '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><path d="M24 10c1.2 3.5 3.8 5.2 8 5.2s6.8-1.7 8-5.2h6c0 8 1.5 13.5 5 17v27H13V27c3.5-3.5 5-9 5-17h6Z"/><path d="M24 10c0 7-2 11-6 14m22-14c0 7 2 11 6 14M17 49h30"/></svg>';
    }
    return '';
  }

function hydrateProductTypeIcons(container) {
    if (!container) return;
    container.querySelectorAll('[data-hjv2-product-type-value]').forEach(function (button) {
      if (button.closest('.hj-color-swatches')) {
        button.innerHTML = colorSwatchMarkup(button.dataset.hjv2ProductTypeValue);
        return;
      }
      var icon = button.querySelector('[data-hjv2-product-type-icon]');
      if (!icon) return;
      var markup = productTypeIconMarkup(button.dataset.hjv2ProductTypeValue);
      icon.innerHTML = markup;
      icon.hidden = !markup;
      button.classList.toggle('has-no-icon', !markup);
    });
  }

function syncProductTypeButtons(container, product, optionInputs) {
    if (!container || !product || !Array.isArray(product.variants)) return;
    var inputs = Array.prototype.slice.call(optionInputs || []);
    var selectedValues = [];
    inputs.forEach(function (input) {
      var rawIndex = input.dataset.hjv2OptionIndex;
      if (rawIndex == null) rawIndex = input.dataset.hjv2BundleOptionIndex;
      var index = parseInt(rawIndex, 10);
      if (Number.isInteger(index)) selectedValues[index] = input.value;
    });
    container.querySelectorAll('[data-hjv2-product-type-value]').forEach(function (button) {
      var index = parseInt(button.dataset.hjv2ProductTypeIndex, 10);
      var value = button.dataset.hjv2ProductTypeValue || '';
      var selected = selectedValues[index] === value;
      var available = product.variants.some(function (variant) {
        return variant.available && Array.isArray(variant.options) && variant.options.every(function (variantValue, optionIndex) {
          if (optionIndex === index) return variantValue === value;
          return selectedValues[optionIndex] == null || variantValue === selectedValues[optionIndex];
        });
      });
      setProp(button, 'disabled', !available);
      if (button.classList.contains('is-selected') !== selected) button.classList.toggle('is-selected', selected);
      setAttr(button, 'aria-pressed', selected ? 'true' : 'false');
      setAttr(button, 'aria-disabled', available ? 'false' : 'true');
    });
  }

function discountRate(quantity, builder) {
    var secondPercent = builder ? Number(builder.dataset.discountPct) : NaN;
    var thirdPercent = builder ? Number(builder.dataset.discountPct3) : NaN;
    if (!Number.isFinite(secondPercent)) secondPercent = 15;
    if (!Number.isFinite(thirdPercent)) thirdPercent = 20;
    secondPercent = Math.max(0, Math.min(100, secondPercent));
    thirdPercent = Math.max(0, Math.min(100, thirdPercent));
    if (quantity >= 3) return thirdPercent / 100;
    if (quantity >= 2) return secondPercent / 100;
    return 0;
  }

function cartVolumeQuantity() {
    var node = document.querySelector('[data-volume-cart-quantity]');
    return scope.hasAttribute('data-ornament-pdp') ? 0 : (node ? Math.max(0, parseInt(node.dataset.volumeCartQuantity, 10) || 0) : 0);
  }

function syncOrnamentOffer(quantity) {
    var percent = Math.round(discountRate(quantity + 1, productRoot) * 100);
    var text = quantity >= 3 ? percent + '% OFF' : 'SAVE ' + percent + '%';
    scope.querySelectorAll('[data-ornament-bundle-saving]').forEach(function (label) {
      setText(label, label.dataset.offerCopy === 'sentence' ? (quantity >= 2 ? 'Save ' + percent + '% + FREE SHIPPING*' : 'Save ' + percent + '% on your set') : text);
      setProp(label, 'hidden', !percent);
      label.title = quantity >= 2 ? 'With 3+ eligible items. US shipping rates up to $15. Message cards excluded from the displayed count.' : '';
    });
    scope.querySelectorAll('[data-ornament-shipping-note]').forEach(function (label) {
      setProp(label, 'hidden', quantity < 2);
    });
  }

function syncOptionControls(variant) {
      if (!variant || !Array.isArray(variant.options)) return;
      elements.optionInputs.forEach(function (input) {
        var index = parseInt(input.dataset.hjv2OptionIndex, 10);
        if (!Number.isInteger(index) || typeof variant.options[index] !== 'string') return;
        var value = variant.options[index];
        var combo = input.closest('.combo');
        input.value = value;
        if (!combo) return;
        var label = combo.querySelector('.combo-label');
        if (label) label.textContent = value;
        combo.querySelectorAll('.combo-option').forEach(function (item) {
          item.classList.toggle('active', item.dataset.value === value);
        });
      });
      syncProductTypeButtons(mainOptionControls, mainProduct, elements.optionInputs);
    }

function syncVariantFromOptions() {
      var current = selectedVariant();
      var optionCount = Array.isArray(productData.options) ? productData.options.length : 0;
      var selectedValues = current && Array.isArray(current.options)
        ? current.options.slice(0, optionCount)
        : new Array(optionCount);

      elements.optionInputs.forEach(function (input) {
        var index = parseInt(input.dataset.hjv2OptionIndex, 10);
        if (Number.isInteger(index) && index >= 0 && index < optionCount) selectedValues[index] = input.value;
      });

      var variant = mainProduct.variants.find(function (item) {
        return item.available && Array.isArray(item.options) && selectedValues.every(function (value, index) {
          return item.options[index] === value;
        });
      });

      if (!variant) {
        syncOptionControls(current);
        return current;
      }

      elements.variantId.value = String(variant.id);
      syncOptionControls(variant);
      return variant;
    }

function purchaseSignature(entries) {
      var designSignature = JSON.stringify((entries || allPurchaseEntries()).map(function (entry) {
        var completed = entry.completed || {};
        return [entry.variant && entry.variant.id, entry.quantity, completed.artworkUrl,
          completed.sessionId, completed.printSide];
      }));
      return messageCard ? JSON.stringify([designSignature, cardSignature()]) : designSignature;
    }

var iconsReady=false;
function syncPurchaseSummary() {
      if(!iconsReady){hydrateProductTypeIcons(mainOptionControls);syncOptionControls(selectedVariant());iconsReady=true;}
      warmGenerationPreview(state);
      bundle.slots.forEach(warmGenerationPreview);
      var entries = allPurchaseEntries();
      var quantity = entries.reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
      var subtotal = entries.reduce(function (sum, entry) {
        return sum + (entry.variant ? Number(entry.variant.price) || 0 : 0) * entry.quantity;
      }, 0);
      var eligibleQuantity = quantity + cartVolumeQuantity();
      var rate = discountRate(eligibleQuantity, productRoot);
      syncOrnamentOffer(eligibleQuantity);
      var savings = entries.reduce(function (sum, entry) {
        return sum + Math.round((entry.variant ? Number(entry.variant.price) || 0 : 0) * rate) * entry.quantity;
      }, 0);
      var addonPrice = cardPrice();
      var total = subtotal - savings + addonPrice;
      if (messageCard && typeof messageCard.setBusy === 'function') messageCard.setBusy(state.addingToCart);
      var generatingPreview = state.processing || bundle.slots.some(function (slot) { return slot.processing; });
      if (elements.atcText) setText(elements.atcText, state.addingToCart ? 'ADDING TO CART' : 'ADD TO CART');
      setAttr(elements.atc, 'aria-busy', state.addingToCart ? 'true' : 'false');
      if (!external) { if (state.addingToCart) setMockupStatus('', '');
      else if (generatingPreview) setMockupStatus('Creating your preview…', 'processing');
      else setMockupStatus('', ''); }
      if (external && !generatingPreview && elements.mockupStatus?.dataset.status === 'processing' && elements.mockupStatus.textContent === 'Creating your preview…') setMockupStatus('', '');
      if (elements.atcPrice) setText(elements.atcPrice, formatMoney(total));
      if (elements.atcOriginalPrice) {
        setText(elements.atcOriginalPrice, rate ? formatMoney(subtotal + addonPrice) : '');
        setProp(elements.atcOriginalPrice, 'hidden', !rate);
      }
      if (elements.saving) {
        setProp(elements.saving, 'hidden', !(state.completed && savings > 0));
        if (elements.savingText) {
          if (scope.hasAttribute('data-ornament-pdp') && savings > 0) {
            var savingAmount = elements.savingText.querySelector('.hj-ornament-saving-amount');
            if (!savingAmount) {
              savingAmount = document.createElement('strong');
              savingAmount.className = 'hj-ornament-saving-amount';
              elements.savingText.replaceChildren(document.createTextNode('You’re saving '), savingAmount);
            }
            setText(savingAmount, formatMoney(savings));
            var shippingReward = elements.savingText.querySelector('.hj-ornament-shipping-reward');
            if (!shippingReward) {
              shippingReward = document.createElement('small');
              shippingReward.className = 'hj-ornament-shipping-reward';
              elements.savingText.appendChild(shippingReward);
            }
            setText(shippingReward, ' + FREESHIPPING');
            setProp(shippingReward, 'hidden', eligibleQuantity < 3);
          } else {
            setText(elements.savingText, savings > 0
              ? 'You save ' + formatMoney(savings) + (quantity >= 3 ? ' + Free Shipping' : '') : '');
          }
        }
      }
      setData(productRoot, 'bundleState', savings > 0 ? 'bundled' : 'single');
      if (elements.bnpl) {
        var threshold = parseInt(elements.bnpl.dataset.bnplThreshold || '3500', 10);
        var eligible = elements.bnpl.querySelector('[data-bnpl-eligible]');
        var ineligible = elements.bnpl.querySelector('[data-bnpl-ineligible]');
        var installmentCount = elements.bnpl.querySelector('#interest_num');
        var installment = elements.bnpl.querySelector('#moneyInstallment');
        var isEligible = total >= threshold;
        var payments = total > 5000 ? 4 : 2;
        if (eligible) setProp(eligible, 'hidden', !isEligible);
        if (ineligible) setProp(ineligible, 'hidden', isEligible);
        if (installmentCount) setText(installmentCount, String(payments));
        if (installment) setText(installment, formatMoney(Math.round(total / payments)));
      }
      renderBundleCards(entries);
      setProp(elements.atc, 'disabled', state.addingToCart || state.processing || !fieldsValid(state, false) || !bundleReadyForCart(entries));
      external?.syncControls?.();
      var galleryState = JSON.stringify([selectedVariant() && selectedVariant().id, !!state.completed, state.galleryKey]);
      if (state.summaryGalleryState !== galleryState) {
        state.summaryGalleryState = galleryState;
        syncMockupGallery();
      }
      if (scope.hasAttribute('data-pdp-ux')) {
        var currentVariant = selectedVariant();
        var purchaseState = {
          stage: state.addingToCart ? 'adding' : generatingPreview ? 'processing' : state.completed ? 'ready' : state.template ? 'initial' : 'loading',
          signature: purchaseSignature(entries), disabled: elements.atc.disabled,
          price: formatMoney(total), unitPrice: currentVariant ? formatMoney(currentVariant.price) : '',
          options: currentVariant ? currentVariant.options : [],
          selection: (currentVariant ? currentVariant.options.join(' / ') : 'Choose your options') +
            (quantity > 1 ? ' · ' + quantity + ' items' : '')
        };
        var purchaseStateKey = JSON.stringify(purchaseState);
        if (scope._hjPurchaseStateKey !== purchaseStateKey) {
          scope._hjPurchaseStateKey = purchaseStateKey;
          scope._hjPurchaseState = purchaseState;
          scope.dispatchEvent(new CustomEvent('havjoy:pdp-purchase-state', { bubbles: true, detail: purchaseState }));
        }
      }
    }

function mainSourceImageUrl() {
      if (!state.template) return '';
      var imageSlot = state.template.slots.find(function (slot) { return slot.type === 'image'; });
      var source=imageSlot && state.values[imageSlot.key];
      return Array.isArray(source) ? source[0] || '' : typeof source==='string' ? source : '';
    }

function bundleSlotById(slotId) {
      return bundle.slots.find(function (slot) { return String(slot.id) === String(slotId); }) || null;
    }

function productVariant(product, variantId) {
      if (!product) return null;
      return product.variants.find(function (variant) { return String(variant.id) === String(variantId); }) || null;
    }

function bundleSelectedVariant(slot) {
      return productVariant(slot.product, slot.variantId);
    }

function productTypeIndex(product) {
      return product && Array.isArray(product.options) ? product.options.findIndex(function (name) {
        return typeof name === 'string' && name.trim().toLowerCase() === 'product type';
      }) : -1;
    }

function bundleResolvedMockup(slot) {
      return window.HavjoyMockupGallery.choose(slot, slot.product, bundleSelectedVariant(slot));
    }

function bundleCompletedMockup(slot) {
      if (!slot.completed) return null;
      var resolved = bundleResolvedMockup(slot);
      return resolved && resolved.overlay ? { key: resolved.key, url: resolved.overlay.url, mockup: resolved } : null;
    }

function applyBundleCompletedMockup(slot) {
      if(slot.ornament){syncPurchaseSummary();return;}
      if (!slot.completed) return;
      var selected = bundleCompletedMockup(slot);
      if (!selected || slot.template.mockupKeys.indexOf(selected.key) === -1) { slot.displayUrl = ''; syncPurchaseSummary(); return; }
      slot.displayUrl = selected.url;
      syncPurchaseSummary();
    }

function cartProperties(completed, selected, variant, fresh) {
      if (!completed || !selected || !selected.key || !selected.url) return null;
      var cacheKey = JSON.stringify([variant && variant.id, selected.key,
        selected.mockup && selected.mockup.sourceMockupKey, completed.artworkUrl,
        completed.printSide, completed.sessionId, completed.originalDesignUrl]);
      var cache = cartPropertiesCache.get(completed);
      if (!cache || cache.snapshot !== completed.designPreview) {
        cache = { snapshot: completed.designPreview, variants: new Map() };
        cartPropertiesCache.set(completed, cache);
      }
      if (!fresh && cache.variants.has(cacheKey)) return cache.variants.get(cacheKey);
      var properties;
      try { properties = window.HavjoyPrintMask.cartProperties(window.HavjoyDesignPreview.properties(completed.designPreview, window.HavjoyPrintMask.artworkUrl(completed.artworkUrl, selected.mockup), variant && variant.id), completed.artworkUrl, selected.mockup); }
      catch (_) { return null; }
      if (completed.printSide !== undefined) {
        if (['front', 'back'].indexOf(completed.printSide) === -1 || !completed.sessionId) return null;
        properties._print_side = completed.printSide;
        properties._template_session_id = completed.sessionId;
        properties._template_mockup_key = selected.mockup && selected.mockup.sourceMockupKey || selected.key;
      }
      if (typeof completed.originalDesignUrl === 'string' && completed.originalDesignUrl) {
        properties._original_design = completed.originalDesignUrl;
      }
      cache.variants.set(cacheKey, properties);
      return properties;
    }

function primaryCompletedMockup(owner, product, variant) {
      if (!owner.completed) return null;
      var resolved = resolveVariantMockup(owner.template, product, variant);
      return resolved && resolved.overlay ? { key: resolved.key, url: resolved.overlay.url, mockup: resolved } : null;
    }

function allPurchaseEntries(fresh) {
      var mainVariant = selectedVariant();
      var mainMockup = !external && state.completed ? chooseCompletedMockup() : null;
      var mainPrimary = external ? null : primaryCompletedMockup(state, mainProduct, mainVariant);
      var entries = [{
        id: 'main',
        title: mainProduct.title,
        product: mainProduct,
        variant: mainVariant,
        mockupKey: mainPrimary ? mainPrimary.key : '',
        quantity: elements.quantity ? Math.max(1, parseInt(elements.quantity.value || '1', 10) || 1) : 1,
        completed: state.completed,
        displayUrl: mainMockup ? mainMockup.url : (state.completed ? '' : mainProduct.image),
        overlay: mainMockup ? {
          mockup: mainMockup.mockup,
          artworkUrl: state.completed.artworkUrl
        } : null,
        properties: cartProperties(state.completed, mainPrimary, mainVariant, fresh),
        isMain: true
      }];
      bundle.slots.forEach(function (slot) {
        var selected = !slot.ornament && slot.completed ? bundleCompletedMockup(slot) : null;
        var primary = slot.ornament ? null : primaryCompletedMockup(slot, slot.product, bundleSelectedVariant(slot));
        entries.push({
          id: String(slot.id),
          title: slot.product ? slot.product.title : slot.title,
          product: slot.product,
          variant: bundleSelectedVariant(slot),
          mockupKey: primary ? primary.key : '',
          quantity: Math.max(1, parseInt(slot.quantity || '1', 10) || 1),
          completed: slot.completed,
          displayUrl: slot.completed ? (selected ? selected.url : '') : (slot.displayUrl || (slot.product && slot.product.image) || slot.image),
          overlay: selected ? {
            mockup: selected.mockup,
            artworkUrl: slot.completed.artworkUrl
          } : null,
          properties: cartProperties(slot.completed, primary, bundleSelectedVariant(slot), fresh),
          isMain: false,
          slot: slot
        });
      });
      return external ? entries.map(function(entry){ return external.entry(entry, entry.slot || state); }) : entries;
    }

function bundleReadyForCart(entries) {
      return (entries || allPurchaseEntries()).every(function (entry) {
        return canShop(entry.slot || state) && entry.variant && entry.variant.available && entry.completed && entry.completed.artworkUrl &&
          entry.mockupKey && entry.properties &&
          !(entry.slot && (entry.slot.loading || entry.slot.processing));
      });
    }

async function prepareCartItems() {
      var entries = allPurchaseEntries(true);
      if (state.processing || !bundleReadyForCart(entries)) throw new Error('Design preview data is unavailable. Please check your selection.');
      var items = await Promise.all(entries.map(async function(entry) {
        if(external && (entry.isMain || entry.slot.ornament)) return external.finalize(entry, entry.slot || state);
        var properties = entry.properties;
        return { id: Number(entry.variant.id), quantity: entry.quantity, properties: properties };
      }));
      if (messageCard) {
        if (typeof messageCard.prepareCartItem !== 'function') throw new Error('The message card is still loading. Please try again.');
        var cardItem = await messageCard.prepareCartItem();
        if (cardItem) items.push(cardItem);
      }
      return items;
    }

function ordinal(number) {
      var noun = scope.hasAttribute('data-ornament-pdp') ? 'ornament' : 'tee';
      return (number === 1 ? '1st' : number === 2 ? '2nd' : number === 3 ? '3rd' : number + 'th') + ' ' + noun;
    }

function appendCardOptions(container, entry) {
      if (!container || !entry.product || !entry.variant) return;
      var structureKey = JSON.stringify([entry.product.id, entry.product.options,
        entry.product.options.map(function (_, i) { return Array.from(new Set(entry.product.variants.map(function(v) { return v.options[i]; }))); })]);
      if (container._hjOptionsKey === structureKey) {
        var inputs = container.querySelectorAll('[data-hjv2-bundle-option-index]');
        var selectionKey = JSON.stringify([entry.variant.id, entry.variant.options, entry.product.variants.map(function(v) { return v.available; })]);
        var inputsChanged = Array.from(inputs).some(function(input) {
          return input.value !== (entry.variant.options[Number(input.dataset.hjv2BundleOptionIndex)] || '');
        });
        if (container._hjSelectionKey !== selectionKey || inputsChanged) {
          inputs.forEach(function(input) {
            var index = Number(input.dataset.hjv2BundleOptionIndex), value = entry.variant.options[index] || '';
            setProp(input, 'value', value);
            var field = input.closest('.hj-tee-set-card__field');
            setText(field.querySelector('.hjv2-option-value'), ' \u00b7 ' + value);
            setText(field.querySelector('.combo-label'), value);
            field.querySelectorAll('.combo-option').forEach(function(option) {
              var active = option.dataset.value === value;
              if (option.classList.contains('active') !== active) option.classList.toggle('active', active);
            });
          });
          syncProductTypeButtons(container, entry.product, inputs);
          container._hjSelectionKey = selectionKey;
        }
        setProp(container.querySelector('[data-hjv2-slot-qty]'), 'value', String(entry.quantity));
        return;
      }
      container._hjOptionsKey = structureKey;
      container._hjSelectionKey = null;
      container.innerHTML = '';
      entry.product.options.forEach(function (name, index) {
        var normalizedName = String(name || '').trim().toLowerCase();
        var isProductType = normalizedName === 'product type' || (scope.hasAttribute('data-ornament-pdp') && normalizedName === 'shape');
        var isColor = normalizedName === 'color' || normalizedName === 'colour';
        var field = document.createElement('div');
        field.className = 'hj-tee-set-card__field' +
          (isProductType ? ' hj-tee-set-card__field--product-type' :
            (normalizedName === 'size' ? ' hj-tee-set-card__field--size' : ' hj-tee-set-card__field--other-option'));
        var label = document.createElement('span');
        label.id = 'HjPurchaseLabel-' + (++nextOptionLabelId);
        label.className = 'hj-tee-info__label';
        label.textContent = name;
        if(external)label.setAttribute('data-help-vi','Chọn tùy chọn cho ornament này. Các ornament khác trong set không thay đổi.');
        var selectedValue = document.createElement('span');
        selectedValue.className = 'hjv2-option-value';
        selectedValue.textContent = ' \u00b7 ' + (entry.variant.options[index] || '');
        label.appendChild(selectedValue);
        field.appendChild(label);
        var values = [];
        entry.product.variants.forEach(function (variant) {
          var value = variant.options[index];
          if (values.indexOf(value) === -1) values.push(value);
        });
        if (isProductType || isColor) {
          var group = document.createElement('div');
          group.className = isColor ? 'hj-color-swatches' : 'hjv2-product-type hjv2-product-type--bundle';
          group.dataset.hjv2ProductTypeGroup = '';
          group.setAttribute('role', 'group');
          group.setAttribute('aria-labelledby', label.id);
          values.forEach(function (value) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = (isColor ? 'hj-color-swatch' : 'hjv2-product-type__button') + (value === entry.variant.options[index] ? ' is-selected' : '');
            button.dataset.hjv2ProductTypeValue = value;
            button.dataset.hjv2ProductTypeIndex = String(index);
            button.setAttribute('aria-pressed', value === entry.variant.options[index] ? 'true' : 'false');
            var icon = document.createElement('span');
            icon.className = 'hjv2-product-type__icon';
            icon.dataset.hjv2ProductTypeIcon = '';
            icon.setAttribute('aria-hidden', 'true');
            var valueLabel = document.createElement('span');
            valueLabel.className = 'hjv2-product-type__label';
            valueLabel.textContent = value;
            var check = document.createElement('span');
            check.className = 'hjv2-product-type__check';
            check.setAttribute('aria-hidden', 'true');
            check.textContent = '\u2713';
            button.appendChild(icon);
            button.appendChild(valueLabel);
            button.appendChild(check);
            group.appendChild(button);
          });
          var productTypeInput = document.createElement('input');
          productTypeInput.type = 'hidden';
          productTypeInput.value = entry.variant.options[index] || '';
          productTypeInput.dataset.hjv2BundleOptionIndex = String(index);
          productTypeInput.dataset.hjv2BundleSlotId = entry.id;
          group.appendChild(productTypeInput);
          field.appendChild(group);
          container.appendChild(field);
          return;
        }
        var combo = document.createElement('div');
        combo.className = 'combo hj-size-combo hj-size-combo--set';
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.setAttribute('aria-labelledby', label.id);
        trigger.className = 'combo-trigger hj-size-combo__trigger';
        var comboLabel = document.createElement('span');
        comboLabel.className = 'combo-label';
        comboLabel.textContent = entry.variant.options[index] || '';
        trigger.appendChild(comboLabel);
        trigger.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>');
        var options = document.createElement('ul');
        options.className = 'combo-options hj-size-combo__options';
        values.forEach(function (value) {
          var item = document.createElement('li');
          item.className = 'combo-option' + (value === entry.variant.options[index] ? ' active' : '');
          item.dataset.value = value;
          item.textContent = value;
          options.appendChild(item);
        });
        var input = document.createElement('input');
        input.type = 'hidden';
        input.className = 'combo-input';
        input.value = entry.variant.options[index] || '';
        input.dataset.hjv2BundleOptionIndex = String(index);
        input.dataset.hjv2BundleSlotId = entry.id;
        combo.appendChild(trigger);
        combo.appendChild(options);
        combo.appendChild(input);
        field.appendChild(combo);
        container.appendChild(field);
      });

      var quantityField = document.createElement('div');
      quantityField.className = 'hj-tee-set-card__field hj-tee-set-card__field--qty';
      var quantityLabel = document.createElement('label');
      quantityLabel.className = 'hj-tee-info__label';
      quantityLabel.textContent = 'Quantity';
      if(external)quantityLabel.setAttribute('data-help-vi','Số lượng của ornament này trong set; từ 1 đến 20.');
      quantityLabel.htmlFor = 'HjPurchaseQuantity-' + (++nextOptionLabelId);
      var quantity = document.createElement('div');
      quantity.className = 'hj-tee-info__qty hj-tee-set-card__qty';
      quantity.innerHTML = '<button type="button" data-hjv2-slot-qty-dec aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" min="1" class="hj-tee-info__qty-input" data-hjv2-slot-qty>' +
        '<button type="button" data-hjv2-slot-qty-inc aria-label="Increase quantity">+</button>';
      quantity.querySelectorAll('button,input').forEach(function (control) {
        control.dataset.hjv2BundleSlotId = entry.id;
      });
      if(external)quantity.querySelector('input').max='20';
      quantity.querySelector('input').value = String(entry.quantity);
      quantity.querySelector('input').id = quantityLabel.htmlFor;
      quantityField.appendChild(quantityLabel);
      quantityField.appendChild(quantity);
      container.appendChild(quantityField);
      hydrateProductTypeIcons(container);
      syncProductTypeButtons(
        container,
        entry.product,
        container.querySelectorAll('[data-hjv2-bundle-option-index]')
      );
      container._hjSelectionKey = JSON.stringify([entry.variant.id, entry.variant.options, entry.product.variants.map(function(v) { return v.available; })]);
    }

function renderBundleCards(entries) {
      if (!elements.bundleBuilder) return;
      entries = entries || allPurchaseEntries();
      var hasAdditional = bundle.slots.length > 0;
      if (elements.bundleEmpty) setProp(elements.bundleEmpty, 'hidden', hasAdditional);
      if (elements.bundleReady) setProp(elements.bundleReady, 'hidden', !hasAdditional);
      setData(productRoot, 'teeSetActive', hasAdditional ? 'true' : 'false');
      if (!hasAdditional || !elements.bundleCards || !elements.bundleCardTemplate) {external?.cardsRendered?.([],elements.bundleCards);return;}
      // Update cards in place: detaching an unchanged card can repaint its images.
      var previousCards = new Map();
      Array.from(elements.bundleCards.children).forEach(function (card) {
        previousCards.set(card.dataset.hjv2BundleSlotId, card);
      });
      var totalQuantity = entries.reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
      var rate = discountRate(totalQuantity + cartVolumeQuantity(), productRoot);
      entries.forEach(function (entry, index) {
        var node = previousCards.get(String(entry.id)) ||
          document.importNode(elements.bundleCardTemplate.content.firstElementChild, true);
        previousCards.delete(String(entry.id));
        setData(node, 'hjv2BundleSlotId', entry.id);
        var label = node.querySelector('[data-slot-label]');
        if (label) setText(label, entry.title || ordinal(index + 1));
        var image = node.querySelector('[data-slot-image]');
        var overlay = node.querySelector('[data-slot-overlay]');
        if (image) {
          setProp(image, 'alt', entry.title || ordinal(index + 1));
          setDisplay(image, entry.overlay ? 'none' : '');
        }
        var previewKey = JSON.stringify([entry.variant && entry.variant.id, entry.displayUrl,
          entry.overlay && entry.overlay.mockup.key, entry.overlay && entry.overlay.artworkUrl, (entry.slot || state).galleryKey]);
        var placement = entry.overlay && entry.overlay.mockup.overlay;
        if (node._hjPreviewKey !== previewKey || node._hjPreviewPlacement !== placement || (entry.overlay && !overlay._hjPreviewRequest)) {
          node._hjPreviewKey = previewKey;
          node._hjPreviewPlacement = placement;
          if (image && image.getAttribute('src') !== (entry.displayUrl || '')) image.src = entry.displayUrl || '';
          if (entry.overlay) setOverlayPreview(overlay, entry.overlay.mockup, entry.overlay.artworkUrl);
          else if (!overlay.hidden || overlay._hjPreviewRequest) hideOverlayPreview(overlay);
          if(!external || (!entry.isMain && !entry.slot.ornament)) syncBundleGallery(node, entry, overlay, image);
        }
        var edit = node.querySelector('[data-slot-edit]');
        if (edit) {
          setData(edit, 'hjv2BundleSlotId', entry.id);
          if(external)edit.setAttribute('data-help-vi','Sửa ảnh hoặc nội dung của Design này. Các Design khác trong set được giữ nguyên.');
          setProp(edit, 'disabled', !!(entry.slot && (entry.slot.loading || entry.slot.processing)));
          setAttr(edit, 'aria-disabled', edit.disabled ? 'true' : 'false');
        }
        var remove = node.querySelector('[data-slot-remove]');
        if (remove) {
          setData(remove, 'hjv2BundleSlotId', entry.id);
          if(external)remove.setAttribute('data-help-vi','Xóa ornament này khỏi set đang chọn; không xóa món đã có trong cart.');
          setProp(remove, 'hidden', entry.isMain);
        }
        var optionsHost=node.querySelector('.hj-tee-set-card__main-options');
        optionsHost.hidden=!canShop(entry.slot || state);
        if(!optionsHost.hidden)appendCardOptions(optionsHost, entry);
        var price = entry.variant ? entry.variant.price : 0;
        var discounted = Math.max(0, price - Math.round(price * rate));
        var priceNode = node.querySelector('[data-slot-price]');
        var originalNode = node.querySelector('[data-slot-original-price]');
        if (priceNode) setText(priceNode, formatMoney(discounted));
        if (originalNode) {
          setText(originalNode, formatMoney(price));
          setProp(originalNode, 'hidden', rate === 0);
        }
        var currentNode = elements.bundleCards.children[index];
        if (currentNode !== node) elements.bundleCards.insertBefore(node, currentNode || null);
      });
      previousCards.forEach(function (card) {
        hideOverlayPreview(card.querySelector('[data-slot-overlay]'));
        card.remove();
      });
      external?.cardsRendered?.(entries,elements.bundleCards);
    }

function invalidateBundleSlot(slot) {
      slot.generation += 1;
      if (slot.stopWatchingJob) slot.stopWatchingJob();
      clearLoadingMessageTimer(slot);
      slot.completed = null;
      slot.processing = false;
      slot.displayUrl = slot.product ? slot.product.image : slot.image;
      syncPurchaseSummary();
    }

function renderBundleFields(slot) {
      fileInput.multiple = multiPhoto.enabled(slot);
      elements.dynamicForm.innerHTML = '';
      slot.inputs = {};
      fileInput.accept = slot.template.upload.types.join(',');
      var imageIndex = 0;
      slot.template.slots.forEach(function (field, index) {
        var group = document.createElement('div');
        group.className = 'form-group';
        var id = 'Hjv2BundleField-' + slot.id + '-' + index;
        var label = document.createElement('label');
        label.htmlFor = id;
        label.textContent = field.label + (field.required ? ' *' : '');
        group.appendChild(label);
        var input;
        if (field.type === 'image') {
          imageIndex += 1;
          if (imageIndex === 1) {
            input = fileInput;
            group.hidden = true;
          } else {
            input = document.createElement('input');
            input.type = 'file';
            input.id = id;
            input.accept = slot.template.upload.types.join(',');
            input.className = 'hjv2-extra-file';
            var status = document.createElement('span');
            status.className = 'hjv2-extra-file-status';
            status.textContent = slot.values[field.key] ? 'Image uploaded.' : 'Maximum ' + Math.ceil(slot.template.upload.maxBytes / 1048576) + ' MB.';
            input.addEventListener('change', function () {
              uploadPersonalizationFile(slot, field.key, input.files && input.files[0], status, {
                clearValue: true,
                invalidate: function () { invalidateBundleSlot(slot); }
              });
            });
            group.appendChild(input);
            group.appendChild(status);
          }
        } else {
          input = document.createElement('input');
          input.type = 'text';
          input.id = id;
          input.required = field.required;
          input.value = slot.values[field.key] || '';
          if (field.minLength !== null) input.minLength = field.minLength;
          if (field.maxLength !== null) input.maxLength = field.maxLength;
          input.addEventListener('input', function () {
            slot.values[field.key] = input.value;
            invalidateBundleSlot(slot);
            validateField(slot, field, false);
          });
          group.appendChild(input);
          appendTextSuggestions(group, input, field);
        }
        slot.inputs[field.key] = input;
        var error = document.createElement('span');
        error.className = 'hjv2-field-error';
        error.hidden = true;
        group.appendChild(error);
        elements.dynamicForm.appendChild(group);
      });
      external?.fieldsRendered?.(slot, elements.dynamicForm);
    }

async function handleBundlePrimaryFile(slot, file) {
      if (!slot || !file || slot.loading || slot.processing || !slot.template || !isModalOwner(slot)) return;
      clearError();
      var firstImage = slot.template.slots.find(function (field) { return field.type === 'image'; });
      if (!firstImage) return;
      var key = firstImage.key;
      setLocalPhotoPreview(slot, file);
      showUploadStep();
      await uploadPersonalizationFile(slot, key, file, null, {
        clearValue: true,
        primary: true,
        invalidate: function () { invalidateBundleSlot(slot); }
      });
      if (isModalOwner(slot) && slot.modalStage === 'upload') showUploadStep();
    }

async function fetchBundleProduct(handle, fallback) {
      if (bundle.productCache[handle]) return bundle.productCache[handle];
      var response = await fetchWithTimeout('/products/' + encodeURIComponent(handle) + '.js', {
        method: 'GET', headers: { Accept: 'application/json' }
      }, REQUEST_TIMEOUT_MS);
      if (!response.ok) throw new Error('Product unavailable');
      var product = normalizeProduct(await response.json(), fallback);
      if (!product) throw new Error('Invalid product');
      bundle.productCache[handle] = product;
      return product;
    }

async function resolveBundleFlow(slot, handle, fallback) {
      if(external && await external.load(slot, handle, fallback, fetchBundleProduct)) return;
      var results = await Promise.all([
        fetchBundleProduct(handle, fallback),
        loadPersonalizationTemplate(handle)
      ]);
      slot.product = results[0];
      slot.product.variantBackgroundOnly = mainProduct.variantBackgroundOnly;
      slot.template = window.HavjoyMockupGallery.withVariantBackgrounds(results[1], slot.product);
    }

function canReuseBundlePhoto(slot) {
      // Use the same API requirements as the upload UI; unknown settings never opt in.
      return [state.template, slot.template].every(function (template) {
        var photo = template && template.photoUpload;
        return template && template.photoUploadKnown && photo.multiple === false &&
          Number(photo.min) === 1 && Number(photo.max) === 1;
      });
    }

async function createBundleSlot(trigger) {
      var slot = {
        id: bundle.nextId++,
        title: trigger.dataset.title || 'Custom tee',
        image: trigger.dataset.image || '',
        product: null,
        variantId: '',
        quantity: 1,
        template: null,
        values: {},
        inputs: {},
        uploadVersions: {},
        uploadsInFlight: 0,
        generation: 0,
        completed: null,
        processing: false,
        loading: true,
        displayUrl: trigger.dataset.image || '',
        photoPreviewUrl: '',
        localPhotoPreviewUrl: '',
        modalStage: 'upload'
      };
      bundle.slots.push(slot);
      bundle.activeSlot = slot;
      syncPurchaseSummary();
      closeBundlePicker();
      openModal();
      elements.dynamicForm.innerHTML = '';
      showProcessing();
      setStatus('Loading personalization options…', true);
      setMockupStatus('Loading personalization options…', 'loading');
      try {
        await resolveBundleFlow(slot, trigger.dataset.handle, {
          handle: trigger.dataset.handle,
          title: slot.title,
          image: slot.image
        });
        if (bundle.slots.indexOf(slot) === -1) return;
        var firstAvailable = slot.product.variants.find(function (variant) { return variant.available; }) || slot.product.variants[0];
        slot.variantId = firstAvailable.id;
        slot.displayUrl = slot.product.image || slot.image;
        slot.loading = false;
        multiPhoto.restore(slot);
        var reuseUrl = canReuseBundlePhoto(slot) ? mainSourceImageUrl() : '';
        if (bundle.slots.indexOf(slot) === -1) return;
        if (reuseUrl) {
          slot.photoPreviewUrl = reuseUrl;
          var firstImage = slot.template.slots.find(function (field) { return field.type === 'image'; });
          if (firstImage) slot.values[firstImage.key] = reuseUrl;
        }
        syncPurchaseSummary();
        if (bundle.activeSlot !== slot) clearLoadingMessageTimer(slot);
        if (bundle.activeSlot === slot) {
          renderBundleFields(slot);
          if (!slot.template.slots.some(function (field) { return field.type === 'image'; })) showDetails();
          else showUploadStep();
        }
      } catch (error) {
        slot.loading = false;
        clearLoadingMessageTimer(slot);
        revokeLocalPhotoPreview(slot);
        bundle.slots = bundle.slots.filter(function (item) { return item !== slot; });
        syncPurchaseSummary();
        if (bundle.activeSlot !== slot) return;
        bundle.activeSlot = null;
        elements.dynamicForm.innerHTML = '';
        showDetails();
        elements.confirm.disabled = true;
        showError('Could not load this product. Please close this window and choose another design.');
      }
    }

function openBundleSlot(slot) {
      if (!slot || slot.loading || slot.processing || !slot.template) {
        setLive(slot && slot.processing ? 'This preview is still being created.' : 'Personalization options are still loading.');
        return;
      }
      bundle.activeSlot = slot;
      renderBundleFields(slot);
      openModal();
      if (!slot.template.slots.some(function (field) { return field.type === 'image'; })) {
        showDetails();
      } else {
        showUploadStep();
      }
    }

function openMainSlot() {
      if (state.processing) {
        setLive('This preview is still being created.');
        return;
      }
      bundle.activeSlot = null;
      renderFields();
      openModal();
      if (state.template.slots.some(function (field) { return field.type === 'image'; })) showUploadStep();
      else showDetails();
    }

var bundleListPromise=null;
function loadBundleList() {
      var host=elements.bundlePicker.querySelector('[data-hj-bundle-lazy]');
      if(!host || host.dataset.loaded==='true')return Promise.resolve();
      if(bundleListPromise)return bundleListPromise;
      host.textContent='Loading designs…';
      bundleListPromise=(host.dataset.collectionUrl
        ? fetchWithTimeout(host.dataset.collectionUrl+'?section_id=hj-bundle-picker',{headers:{Accept:'text/html'}},15000).then(function(r){if(!r.ok)throw new Error('Could not load designs');return r.text();})
        : Promise.resolve('<div data-hj-bundle-results></div>')).then(function(html){
        var result=new DOMParser().parseFromString(html,'text/html').querySelector('[data-hj-bundle-results]');
        if(!result)throw new Error('Could not load designs');
        var own=elements.bundlePicker.querySelector('[data-hj-bundle-current]');
        host.textContent='';if(own)host.appendChild(own.content.cloneNode(true));
        result.querySelectorAll('[data-handle]').forEach(function(card){if(card.dataset.handle!==mainProduct.handle)host.appendChild(card);});
        host.dataset.loaded='true';
      }).catch(function(){
        bundleListPromise=null;host.textContent='Designs could not load. ';
        var retry=document.createElement('button');retry.type='button';retry.textContent='Retry';
        retry.addEventListener('click',function(){loadBundleList();});host.appendChild(retry);
      });
      return bundleListPromise;
    }
function openBundlePicker() {
      if (!elements.bundlePicker) return;
      elements.bundlePicker.hidden = false;
      document.documentElement.classList.add('hj-tee-set-picker-open');
      loadBundleList();
    }

function closeBundlePicker() {
      if (!elements.bundlePicker) return;
      elements.bundlePicker.hidden = true;
      document.documentElement.classList.remove('hj-tee-set-picker-open');
    }

function removeBundleSlot(slot) {
      slot.generation += 1;
      if (slot.stopWatchingJob) slot.stopWatchingJob();
      Object.keys(slot.uploadVersions || {}).forEach(function (key) { slot.uploadVersions[key] += 1; });
      clearLoadingMessageTimer(slot);
      revokeLocalPhotoPreview(slot);
      bundle.slots = bundle.slots.filter(function (item) { return item !== slot; });
      if (bundle.activeSlot === slot) bundle.activeSlot = null;
      syncPurchaseSummary();
    }

function syncBundleVariantFromCard(input) {
      var slotId = input.dataset.hjv2BundleSlotId;
      if (slotId === 'main') {
        var mainInputs = Array.prototype.slice.call(elements.bundleCards.querySelectorAll('[data-hjv2-bundle-slot-id="main"] [data-hjv2-bundle-option-index]'));
        var values = selectedVariant().options.slice();
        mainInputs.forEach(function (control) { values[parseInt(control.dataset.hjv2BundleOptionIndex, 10)] = control.value; });
        var mainVariant = mainProduct.variants.find(function (variant) {
          return variant.available && values.every(function (value, index) { return variant.options[index] === value; });
        });
        if (mainVariant) elements.variantId.value = String(mainVariant.id);
        syncOptionControls(selectedVariant());
        if (state.completed) applyCompletedMockup();
        else syncPurchaseSummary();
        return;
      }
      var slot = bundleSlotById(slotId);
      if (!slot) return;
      var current = bundleSelectedVariant(slot);
      var selectedValues = current.options.slice();
      var card = input.closest('.hj-tee-set-card');
      card.querySelectorAll('[data-hjv2-bundle-option-index]').forEach(function (control) {
        selectedValues[parseInt(control.dataset.hjv2BundleOptionIndex, 10)] = control.value;
      });
      var variant = slot.product.variants.find(function (item) {
        return item.available && selectedValues.every(function (value, index) { return item.options[index] === value; });
      });
      if (variant) slot.variantId = String(variant.id);
      if (slot.completed) applyBundleCompletedMockup(slot);
      else syncPurchaseSummary();
    }

async function completeBundleGeneration(slot, artworkUrl, originalDesignUrl, token, generation) {
      if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
      var completed = createCompletedResult(slot.template, artworkUrl, originalDesignUrl, generation, slot.product);
      var resolved = bundleCompletedMockup(Object.assign({}, slot, { completed: completed }));
      if (!resolved || !resolved.mockup || !resolved.mockup.overlay) throw new Error('Invalid client overlay template');
      if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
      clearLoadingMessageTimer(slot);
      slot.completed = completed;
      slot.processing = false;
      var safariPosition = null;
      if (isSafari && isModalOwner(slot) && modal.open) {
        setStatus('Your preview is ready.', false);
        resetLoadingVisual(slot);
        safariPosition = await closeSafariModalBeforePageUpdate(slot);
        if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
        bundle.activeSlot = null;
      }
      applyBundleCompletedMockup(slot);
      preserveSafariPagePosition(safariPosition);
    }

async function generateBundleV2(slot, token, pending) {
      if(slot.ornament){if(pending)await pending.resume();else await external.generate(slot, token); if(token===slot.generation && bundle.slots.includes(slot)){clearLoadingMessageTimer(slot);slot.processing=false;syncPurchaseSummary();}return;}
      if(pending){await pending.resume();return;}
      await submitGenerationJob({
        owner: slot,
        template: slot.template,
        productHandle: slot.product.handle,
        token: token,
        label: 'bundle generation #' + slot.id,
        isActive: function () { return bundle.activeSlot === slot; },
        onCompleted: function (artworkUrl, sessionId, originalDesignUrl, generation) {
          return completeBundleGeneration(slot, artworkUrl, originalDesignUrl, token, generation);
        }
      });
    }

async function generateBundleSlot(slot) {
      clearError();
      if (!slot || slot.loading || !slot.template || !slot.product || slot.processing) return;
      // A session that lost its connection is only read again, never re-submitted.
      var pending = pendingJobFor(slot);
      if (!pending) {
        if (slot.uploadsInFlight > 0) { showError('Please wait for your image to finish uploading.'); return; }
        if (!fieldsValid(slot, true)) return;
        var variant = bundleSelectedVariant(slot);
        if (!variant || !variant.available) { showError('Please choose an available variant.'); return; }
        invalidateBundleSlot(slot);
      }
      slot.pendingJob = null;
      var token = slot.generation;
      slot.processing = true;
      syncPurchaseSummary();
      if (isModalOwner(slot)) showProcessing();
      try {
        await generateBundleV2(slot, token, pending);
        if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
        if (isModalOwner(slot)) {
          setStatus('Your preview is ready.', false);
          resetLoadingVisual(slot);
          bundle.activeSlot = null;
          closeModal();
        }
      } catch (error) {
        if (token !== slot.generation || bundle.slots.indexOf(slot) === -1) return;
        clearLoadingMessageTimer(slot);
        slot.processing = false;
        // Bundle errors previously surfaced error.message; keep that for untyped errors.
        if (error && !error.publicMessage && error.message) error.publicMessage = error.message;
        syncPurchaseSummary();
        showJobError(slot, error, token);
      }
    }
function bindPurchaseUi(){
 scope.addEventListener('havjoy:message-card-change', syncPurchaseSummary);
 scope.addEventListener('click',function(event){
 if(!canShop(state))return;
 var card=event.target.closest('[data-hjv2-bundle-slot-id]');
 if(card && event.target.closest('.hj-tee-set-card__main-options')){
  var owner=card.dataset.hjv2BundleSlotId==='main'?state:bundleSlotById(card.dataset.hjv2BundleSlotId);
  if(!owner || !canShop(owner))return;
 }
         var action = event.target.closest('[data-action]');
        if (action && action.dataset.action === 'open-tee-bundle-picker') {
          event.preventDefault();
          openBundlePicker();
          return;
        }
        if (action && action.dataset.action === 'close-tee-bundle-picker') {
          event.preventDefault();
          closeBundlePicker();
          return;
        }
        if (action && action.dataset.action === 'choose-tee-bundle-product') {
          event.preventDefault();
          createBundleSlot(action);
          return;
        }

        var removeSlotButton = event.target.closest('[data-slot-remove][data-hjv2-bundle-slot-id]');
        if (removeSlotButton) {
          event.preventDefault();
          var removeSlot = bundleSlotById(removeSlotButton.dataset.hjv2BundleSlotId);
          if (removeSlot) removeBundleSlot(removeSlot);
          return;
        }

        var productTypeButton = event.target.closest('[data-hjv2-product-type-value]');
        if (productTypeButton && productTypeButton.closest('.hj-tee-product')) {
          event.preventDefault();
          if (productTypeButton.disabled) return;
          var productTypeGroup = productTypeButton.closest('[data-hjv2-product-type-group]');
          var productTypeInput = productTypeGroup && productTypeGroup.querySelector(
            '[data-hjv2-option-index],[data-hjv2-bundle-option-index]'
          );
          if (!productTypeInput) return;
          productTypeInput.value = productTypeButton.dataset.hjv2ProductTypeValue || '';
          if (productTypeInput.hasAttribute('data-hjv2-bundle-option-index')) {
            syncBundleVariantFromCard(productTypeInput);
          } else {
            syncVariantFromOptions();
            if (state.completed) applyCompletedMockup();
            else syncPurchaseSummary();
          }
          return;
        }

        var option = event.target.closest('.hj-size-combo .combo-option');
        if (option && option.closest('.hj-tee-product')) {
          var combo = option.closest('.combo');
          var input = combo.querySelector('.combo-input');
          var label = combo.querySelector('.combo-label');
          combo.querySelectorAll('.combo-option').forEach(function (item) { item.classList.toggle('active', item === option); });
          if (input) input.value = option.dataset.value || '';
          if (label) label.textContent = option.dataset.value || '';
          combo.classList.remove('open');
          if (input && input.hasAttribute('data-hjv2-bundle-option-index')) {
            syncBundleVariantFromCard(input);
          } else if (input && input.hasAttribute('data-hjv2-option-index')) {
            syncVariantFromOptions();
            if (state.completed) applyCompletedMockup();
            else syncPurchaseSummary();
          }
          return;
        }

        var trigger = event.target.closest('.hj-size-combo .combo-trigger');
        if (trigger && trigger.closest('.hj-tee-product')) {
          event.preventDefault();
          trigger.closest('.combo').classList.toggle('open');
          return;
        }

        var quantityButton = event.target.closest('[data-qty-dec],[data-qty-inc]');
        if (quantityButton && elements.quantity) {
          event.preventDefault();
          var quantity = Math.max(1, parseInt(elements.quantity.value || '1', 10) || 1);
          elements.quantity.value = String(quantityButton.hasAttribute('data-qty-dec') ? Math.max(1, quantity - 1) : quantity + 1);
          syncPurchaseSummary();
          return;
        }

        var slotQuantityButton = event.target.closest('[data-hjv2-slot-qty-dec],[data-hjv2-slot-qty-inc]');
        if (slotQuantityButton) {
          event.preventDefault();
          var slotId = slotQuantityButton.dataset.hjv2BundleSlotId;
          var quantityInput = slotQuantityButton.parentElement.querySelector('[data-hjv2-slot-qty]');
          var quantityValue = Math.max(1, parseInt(quantityInput.value || '1', 10) || 1);
          quantityValue = slotQuantityButton.hasAttribute('data-hjv2-slot-qty-dec') ? Math.max(1, quantityValue - 1) : quantityValue + 1;
          quantityInput.value = String(quantityValue);
          if (slotId === 'main') {
            elements.quantity.value = String(quantityValue);
          } else {
            var quantitySlot = bundleSlotById(slotId);
            if (quantitySlot) quantitySlot.quantity = quantityValue;
          }
          syncPurchaseSummary();
          return;
        }


 });
       if (elements.quantity) elements.quantity.addEventListener('change', function () {
        if(!canShop(state))return;
        elements.quantity.value = String(Math.max(1, parseInt(elements.quantity.value || '1', 10) || 1));
        syncPurchaseSummary();
      });
      scope.addEventListener('change', function (event) {
        if(!canShop(state))return;
        var slotQuantity = event.target.closest('[data-hjv2-slot-qty]');
        if (!slotQuantity) return;
        var value = Math.max(1, parseInt(slotQuantity.value || '1', 10) || 1);
        slotQuantity.value = String(value);
        var slotId = slotQuantity.dataset.hjv2BundleSlotId;
        if (slotId === 'main') elements.quantity.value = String(value);
        else {
          var changedSlot = bundleSlotById(slotId);
          if (changedSlot) changedSlot.quantity = value;
        }
        syncPurchaseSummary();
      });
      elements.variantId.addEventListener('change', function () {
        if(!canShop(state))return;
        syncOptionControls(selectedVariant());
        if (state.completed) applyCompletedMockup();
        else syncPurchaseSummary();
      });
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (state.addingToCart) return;
        if(!canShop(state))return;
        if (state.processing || !state.completed || !fieldsValid(state, true) || !bundleReadyForCart()) {
          bundle.activeSlot = null;
          renderFields();
          openModal();
          showDetails();
          showError('Generate a valid preview for every design before adding these items to cart.');
          return;
        }
        if (messageCard) {
          if (typeof messageCard.cartItem !== 'function') return;
          try { messageCard.cartItem(); } catch (_) { return; }
        }
        state.addingToCart = true;
        var submittedSignature = purchaseSignature();
        syncPurchaseSummary();
        try {
          var items = await prepareCartItems();
          if (purchaseSignature() !== submittedSignature) throw new Error('Your selection changed. Please review it and add to cart again.');
          if (!fieldsValid(state, false)) throw new Error('Your design details changed. Please review them and try again.');
          var data;
          if(external) data=await external.submit(items);
          else { var response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
          });
          data = await response.json().catch(function () { return {}; });
          if (!response.ok) throw new Error(data.description || 'Could not add these items to cart.'); }
        } catch (error) {
          state.addingToCart = false;
          syncPurchaseSummary();
          bundle.activeSlot = null;
          renderFields();
          openModal();
          showDetails();
          showError(error.message || 'Could not add these items to cart. Please try again.');
          return;
        }

        scope.dispatchEvent(new CustomEvent('havjoy:pdp-cart-added', { bubbles: true, detail: { signature: submittedSignature } }));
        var cartUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        if(window.HavjoyDeferredAssets){try{await window.HavjoyDeferredAssets.ensure('drawer');}catch(_){window.location.href=cartUrl;return;}}
        if (!window.CartDrawerController) {
          window.location.href = cartUrl;
          return;
        }
        try {
          await Promise.resolve(window.CartDrawerController.update(data.sections));
          window.CartDrawerController.open();
          state.addingToCart = false;
          syncPurchaseSummary();
          setLive('Added to cart.');
        } catch (drawerError) {
          console.error('[HavJoy] Cart drawer failed after items were added', drawerError);
          window.location.href = cartUrl;
        }
      }, true);

}
if(external)external.refresh=syncPurchaseSummary;
var bound=false;
return {syncOptionControls,syncVariantFromOptions,purchaseSignature,syncPurchaseSummary,mainSourceImageUrl,bundleSlotById,productVariant,bundleSelectedVariant,productTypeIndex,bundleResolvedMockup,bundleCompletedMockup,applyBundleCompletedMockup,cartProperties,primaryCompletedMockup,allPurchaseEntries,bundleReadyForCart,prepareCartItems,ordinal,appendCardOptions,renderBundleCards,invalidateBundleSlot,renderBundleFields,handleBundlePrimaryFile,fetchBundleProduct,resolveBundleFlow,canReuseBundlePhoto,createBundleSlot,openBundleSlot,openMainSlot,openBundlePicker,closeBundlePicker,removeBundleSlot,syncBundleVariantFromCard,completeBundleGeneration,generateBundleV2,generateBundleSlot,init:function(){if(bound)return;bound=true;bindPurchaseUi();
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var lastCount = cartVolumeQuantity();
    new MutationObserver(function () {
      var nextCount = cartVolumeQuantity();
      if (nextCount !== lastCount) { lastCount = nextCount; syncPurchaseSummary(); }
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-volume-cart-quantity'] });
  }
}};
}};
})();
